import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';

export interface UpdateAmountInvestmentAttempt extends Action {
  type: Types.UPDATE_AMOUNT_INVESTMENT_ATTEMPT;
}

export interface UpdateAmountInvestmentSuccess extends Action {
  type: Types.UPDATE_AMOUNT_INVESTMENT_SUCCESS;
}

export interface UpdateAmountInvestmentFailure extends Action {
  type: Types.UPDATE_AMOUNT_INVESTMENT_FAILURE;
  payload: {};
}

export type UpdateAmountInvestmentAction =
  UpdateAmountInvestmentAttempt |
  UpdateAmountInvestmentSuccess |
  UpdateAmountInvestmentFailure;

export interface UpdateAmountInvestmentThunk extends
  ThunkAction<Promise<UpdateAmountInvestmentAction>, RootState, null> {
}

export const updateAmountInvestmentAttempt: ActionCreator<UpdateAmountInvestmentAttempt> = () => (
  {type: Types.UPDATE_AMOUNT_INVESTMENT_ATTEMPT}
);

export const updateAmountInvestmentSuccess: ActionCreator<UpdateAmountInvestmentSuccess> = () => (
  {
    type: Types.UPDATE_AMOUNT_INVESTMENT_SUCCESS,
  }
);

export const updateAmountInvestmentFailure: ActionCreator<UpdateAmountInvestmentFailure> = (error: {}) => (
  {
    type: Types.UPDATE_AMOUNT_INVESTMENT_FAILURE,
    payload: error
  }
);

export const updateAmountInvestment: ActionCreator<UpdateAmountInvestmentThunk> = (
  investmentId: number,
  error: string,
  message: string
): UpdateAmountInvestmentThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateAmountInvestmentAction> => {

    dispatch(updateAmountInvestmentAttempt());

    return ApiClient.changeAmount.create({error: error, message: message}, {investmentId: investmentId})
      .then((response: AxiosResponse): UpdateAmountInvestmentSuccess => {
        return dispatch(updateAmountInvestmentSuccess());
      }).catch((e: { response: { data: { errors: {} } } }): UpdateAmountInvestmentFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.errors);

        return dispatch(updateAmountInvestmentFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/update-amount/UpdateAmountInvestment.actions.tsx